import { Stack, Typography } from '@mui/material'
import SimpleSelect, { SelectValue } from 'components/select/SimpleSelect'
import WeekPicker from 'components/weekPicker/WeekPicker'
import { useDateRangeOptions } from 'features/Reports/hooks/useDateRangeOptions'
import { UIDateRange } from 'features/UI'
import { Moment } from 'moment/moment'
import { DateInterval, DateRangeType } from 'types'

const optionsRange = Object.keys(DateRangeType).map((it) => ({
  label: it,
  value: it,
}))

export const DateRangeToolbar = ({
  rangeType,
  year,
  month,
  selectedDate,
  dateInterval,
  onChangeDateInterval,
  onChangeRange,
  onChangeYear,
  onChangeMonth,
  setSelectedDate,
  children,
  containerProps,
}: {
  rangeType: string
  year: string
  month: string
  selectedDate: Moment
  dateInterval: DateInterval
  onChangeDateInterval: (value: DateInterval) => void
  onChangeRange: (name: string, value: SelectValue) => void
  onChangeYear: (name: string, value: SelectValue) => void
  onChangeMonth: (name: string, value: SelectValue) => void
  setSelectedDate: (value: Moment) => void
  children?: React.ReactNode
  containerProps?: React.ComponentProps<typeof Stack>
}) => {
  const { monthOptions, optionsYear, maxDate } = useDateRangeOptions(rangeType, year, month)

  let component = null
  if (rangeType === DateRangeType.Yearly) {
    component = (
      <SimpleSelect
        options={optionsYear}
        onChange={onChangeYear}
        name="year"
        value={year}
        sx={{ minWidth: 100 }}
      />
    )
  }
  if (rangeType === DateRangeType.Monthly) {
    component = (
      <>
        <SimpleSelect
          options={optionsYear}
          onChange={onChangeYear}
          name="year"
          value={year}
          sx={{ minWidth: 100 }}
        />
        <SimpleSelect options={monthOptions} onChange={onChangeMonth} name="moth" value={month} />
      </>
    )
  }
  if (rangeType === DateRangeType.Weekly) {
    component = (
      <WeekPicker
        selectedDate={selectedDate}
        maxDate={maxDate.toDate()}
        onChangeSelectedDate={setSelectedDate}
      />
    )
  }

  if (rangeType === DateRangeType.Range) {
    component = (
      <UIDateRange value={dateInterval} maxDate={maxDate} onChange={onChangeDateInterval} />
    )
  }

  return (
    <Stack direction="row" spacing={2} alignItems="center" {...containerProps}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography>Period</Typography>
        <SimpleSelect
          options={optionsRange}
          onChange={onChangeRange}
          name="rangeType"
          value={rangeType}
          sx={{ minWidth: 110 }}
        />
      </Stack>
      <Stack direction="row" spacing={1} alignItems="center">
        {component}
        {children}
      </Stack>
    </Stack>
  )
}
